// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"6c53830f","213":"e7a3dc6b","239":"347dac1b","244":"1983c8c2","409":"ee3dadf4","542":"461be0ff","596":"0fd0117a","732":"5acf3c05","762":"ed448958"}[chunkId] + ".chunk.js";
};